import './assets/sass/main.scss';
import '@swapin/ui/dist/style.css';
import '@swapin/web3/dist/style.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import i18n from '@swapin-hub/i18n';
import { createModal } from '@swapin/ui/Modal';
import { Web3Plugin } from '@swapin/web3';

import App from './App.vue';
import router from './router';
import routerScrollRestore from './router/scrollRestore';
import apiInterceptors from './api/interceptors';

const app = createApp(App);

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: 'https://4f96dbd6b583c0625cd5601bab768cc3@o1262827.ingest.sentry.io/4505996576292864',
    release: __APP_VERSION__,
    environment: import.meta.env.VITE_ENV_DEV ? 'development' : 'production',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    tracesSampleRate: 1,
    tracePropagationTargets: [
      'widget.piix.eu',
      'widget.swapin.com',
    ],
  });
}

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(createModal());
app.use(Web3Plugin);

routerScrollRestore(router);
apiInterceptors(router);

app.mount('#app');
